import React from "react";

import PageLayout from "$src/core/components/templates/PageLayout";
import IntroPage from "$src/core/pages/IntroPage/IntroPage";

const Route: React.FC = () => (
  <PageLayout>
    <IntroPage />
  </PageLayout>
);

export default Route;
